
export const primitive = {
    borderRadius: {
        none: '0',
        xs: '2px',
        sm: '4px',
        md: '8px',       // Card tier — cards, inputs, inline elements
        lg: '12px',      // Panel tier — overlays, dropdowns, dialogs, panels
        xl: '16px'       // Modal tier — full-screen modals
  },

    // Branduals colors - Updated color scheme
    primary: { 50: '#fff5ed', 100: '#ffe8d5', 200: '#ffd3ae', 300: '#ffb078', 400: '#ff7d3f', 500: '#ef4600', 600: '#d73e00', 700: '#bf3600', 800: '#a72e00', 900: '#8f2600', 950: '#771e00' },
    secondary: { 50: '#e6f0ff', 100: '#cce1ff', 200: '#99c3ff', 300: '#77A5D1', 400: '#5593c9', 500: '#003B6F', 600: '#003564', 700: '#002f59', 800: '#00294e', 900: '#002343', 950: '#001d38' },

  // Keep semantic colors
    emerald: { 50: '#ecfdf5', 100: '#d1fae5', 200: '#a7f3d0', 300: '#6ee7b7', 400: '#34d399', 500: '#10b981', 600: '#059669', 700: '#047857', 800: '#065f46', 900: '#064e3b', 950: '#022c22' },
    green: { 50: '#f0fdf4', 100: '#dcfce7', 200: '#bbf7d0', 300: '#86efac', 400: '#4ade80', 500: '#22c55e', 600: '#16a34a', 700: '#15803d', 800: '#166534', 900: '#14532d', 950: '#052e16' },
    lime: { 50: '#f7fee7', 100: '#ecfccb', 200: '#d9f99d', 300: '#bef264', 400: '#a3e635', 500: '#84cc16', 600: '#65a30d', 700: '#4d7c0f', 800: '#3f6212', 900: '#365314', 950: '#1a2e05' },
    red: { 50: '#fef2f2', 100: '#fee2e2', 200: '#fecaca', 300: '#fca5a5', 400: '#f87171', 500: '#ef4444', 600: '#dc2626', 700: '#b91c1c', 800: '#991b1b', 900: '#7f1d1d', 950: '#450a0a' },
    orange: { 50: '#fff7ed', 100: '#ffedd5', 200: '#fed7aa', 300: '#fdba74', 400: '#fb923c', 500: '#f97316', 600: '#ea580c', 700: '#c2410c', 800: '#9a3412', 900: '#7c2d12', 950: '#431407' },
    amber: { 50: '#fffbeb', 100: '#fef3c7', 200: '#fde68a', 300: '#fcd34d', 400: '#fbbf24', 500: '#f59e0b', 600: '#d97706', 700: '#b45309', 800: '#92400e', 900: '#78350f', 950: '#451a03' },
    yellow: { 50: '#fefce8', 100: '#fef9c3', 200: '#fef08a', 300: '#fde047', 400: '#facc15', 500: '#eab308', 600: '#ca8a04', 700: '#a16207', 800: '#854d0e', 900: '#713f12', 950: '#422006' },
    teal: { 50: '#f0fdfa', 100: '#ccfbf1', 200: '#99f6e4', 300: '#5eead4', 400: '#2dd4bf', 500: '#14b8a6', 600: '#0d9488', 700: '#0f766e', 800: '#115e59', 900: '#134e4a', 950: '#042f2e' },
    cyan: { 50: '#ecfeff', 100: '#cffafe', 200: '#a5f3fc', 300: '#67e8f9', 400: '#22d3ee', 500: '#06b6d4', 600: '#0891b2', 700: '#0e7490', 800: '#155e75', 900: '#164e63', 950: '#083344' },
    sky: { 50: '#f0f9ff', 100: '#e0f2fe', 200: '#bae6fd', 300: '#7dd3fc', 400: '#38bdf8', 500: '#0ea5e9', 600: '#0284c7', 700: '#0369a1', 800: '#075985', 900: '#0c4a6e', 950: '#082f49' },
    blue: { 50: '#eff6ff', 100: '#dbeafe', 200: '#bfdbfe', 300: '#93c5fd', 400: '#60a5fa', 500: '#3b82f6', 600: '#2563eb', 700: '#1d4ed8', 800: '#1e40af', 900: '#1e3a8a', 950: '#172554' },
    indigo: { 50: '#eef2ff', 100: '#e0e7ff', 200: '#c7d2fe', 300: '#a5b4fc', 400: '#818cf8', 500: '#6366f1', 600: '#4f46e5', 700: '#4338ca', 800: '#3730a3', 900: '#312e81', 950: '#1e1b4b' },
    violet: { 50: '#f5f3ff', 100: '#ede9fe', 200: '#ddd6fe', 300: '#c4b5fd', 400: '#a78bfa', 500: '#8b5cf6', 600: '#7c3aed', 700: '#6d28d9', 800: '#5b21b6', 900: '#4c1d95', 950: '#2e1065' },
    purple: { 50: '#faf5ff', 100: '#f3e8ff', 200: '#e9d5ff', 300: '#d8b4fe', 400: '#c084fc', 500: '#a855f7', 600: '#9333ea', 700: '#7e22ce', 800: '#6b21a8', 900: '#581c87', 950: '#3b0764' },
    fuchsia: { 50: '#fdf4ff', 100: '#fae8ff', 200: '#f5d0fe', 300: '#f0abfc', 400: '#e879f9', 500: '#d946ef', 600: '#c026d3', 700: '#a21caf', 800: '#86198f', 900: '#701a75', 950: '#4a044e' },
    pink: { 50: '#fdf2f8', 100: '#fce7f3', 200: '#fbcfe8', 300: '#f9a8d4', 400: '#f472b6', 500: '#ec4899', 600: '#db2777', 700: '#be185d', 800: '#9d174d', 900: '#831843', 950: '#500724' },
    rose: { 50: '#fff1f2', 100: '#ffe4e6', 200: '#fecdd3', 300: '#fda4af', 400: '#fb7185', 500: '#f43f5e', 600: '#e11d48', 700: '#be123c', 800: '#9f1239', 900: '#881337', 950: '#4c0519' },
    slate: { 50: '#f8fafc', 100: '#f1f5f9', 200: '#e2e8f0', 300: '#cbd5e1', 400: '#94a3b8', 500: '#64748b', 600: '#475569', 700: '#334155', 800: '#1e293b', 900: '#0f172a', 950: '#020617' },
    gray: { 50: '#f9fafb', 100: '#f3f4f6', 200: '#e5e7eb', 300: '#d1d5db', 400: '#9ca3af', 500: '#6b7280', 600: '#4b5563', 700: '#374151', 800: '#1f2937', 900: '#111827', 950: '#030712' },
    zinc: { 50: '#fafafa', 100: '#f4f4f5', 200: '#e4e4e7', 300: '#d4d4d8', 400: '#a1a1aa', 500: '#71717a', 600: '#52525b', 700: '#3f3f46', 800: '#27272a', 900: '#18181b', 950: '#09090b' },
    neutral: { 50: '#fafafa', 100: '#f5f5f5', 200: '#e5e5e5', 300: '#d4d4d4', 400: '#a3a3a3', 500: '#737373', 600: '#525252', 700: '#404040', 800: '#262626', 900: '#171717', 950: '#0a0a0a' },
    stone: { 50: '#fafaf9', 100: '#f5f5f4', 200: '#e7e5e4', 300: '#d6d3d1', 400: '#a8a29e', 500: '#78716c', 600: '#57534e', 700: '#44403c', 800: '#292524', 900: '#1c1917', 950: '#0c0a09' }
};

export const semantic = {
    transitionDuration: '0.2s',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    spacing: {
        appToolbarHeight: '48px',
        sidebarWidth: '256px',
        panelHeaderHeight: '52px',
        searchWidth: '384px'
    },
    cardShadow: '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
    info: {
        color: '{sky.600}',
        background: 'color-mix(in srgb, {sky.500} 10%, transparent)',
        border: 'color-mix(in srgb, {sky.500} 30%, transparent)'
    },
    success: {
        color: '{green.600}',
        background: 'color-mix(in srgb, {green.500} 10%, transparent)',
        border: 'color-mix(in srgb, {green.500} 30%, transparent)'
    },
    warning: {
        color: '{amber.600}',
        background: 'color-mix(in srgb, {amber.500} 10%, transparent)',
        border: 'color-mix(in srgb, {amber.500} 30%, transparent)'
    },
    danger: {
        color: '{red.500}',
        background: 'color-mix(in srgb, {red.500} 10%, transparent)',
        border: 'color-mix(in srgb, {red.500} 30%, transparent)'
    },
    contrast: {
        color: '#ffffff'
    },
    datatable: {
        border: {
            color: '{surface.200}'
        }
    },
    fontSize: {
        xs: '0.75rem',      // 12px
        sm: '0.875rem',     // 14px
        base: '1rem',       // 16px
        lg: '1.125rem',     // 18px
        xl: '1.25rem',      // 20px
        '2xl': '1.5rem',    // 24px
        '3xl': '1.875rem',  // 30px
        '4xl': '2.25rem',   // 36px
        '5xl': '3rem',      // 48px
    },
    fontWeight: {
        thin: '100',
        extralight: '200',
        light: '300',
        regular: '400',
        medium: '500',
        semibold: '600',
        bold: '700',
        extrabold: '800',
        black: '900'
    },
    typography: {
        h1: {
            fontSize: '3.0rem',
            fontWeight: '700',
            lineHeight: '1.2',
            letterSpacing: '-0.02em'
        },
        h2: {
            fontSize: '2.2rem',
            fontWeight: '300', // Light weight for modern look
            lineHeight: '1.3',
            letterSpacing: '-0.01em'
        },
        h3: {
            fontSize: '1.8rem',
            fontWeight: '300', // Light weight
            lineHeight: '1.4',
            letterSpacing: '0'
        },
        body: {
            fontSize: '1rem',
            fontWeight: '400',
            lineHeight: '1.6',
            letterSpacing: '0'
        },
        button: {
            fontSize: '0.8125rem', // 13px - refined
            fontWeight: '500', // Medium weight — gives buttons authority
            lineHeight: '1.5',
            letterSpacing: '0.01em'
        },
        navigation: {
            fontSize: '0.875rem', // 14px
            fontWeight: '400',
            lineHeight: '1.5',
            letterSpacing: '0'
        },
        metadata: {
            fontSize: '0.75rem', // 12px
            fontWeight: '400',
            lineHeight: '1.5',
            letterSpacing: '0'
        },
        // Form labels - light weight per design guidelines
        label: {
            fontSize: '0.8125rem', // 13px
            fontWeight: '300', // Light weight
            lineHeight: '1.5',
            letterSpacing: '0'
        },
        // Uppercase section headers
        sectionHeader: {
            fontSize: '0.6875rem', // 11px
            fontWeight: '400',
            lineHeight: '1.5',
            letterSpacing: '0.05em',
            textTransform: 'uppercase'
        }
    },
    focusRing: {
        width: '2px',
        style: 'solid',
        color: '{primary.500}',
        offset: '2px'
    },
    disabledOpacity: '0.6',
    iconSize: '1rem',
    anchorGutter: '2px',
    shadow: {
        xs: '0 1px 2px rgba(0, 0, 0, 0.05)',
        sm: '0 2px 4px rgba(0, 0, 0, 0.08)',
        md: '0 4px 12px rgba(0, 0, 0, 0.12)',
        lg: '0 8px 24px rgba(0, 0, 0, 0.15)',
        xl: '0 12px 48px rgba(0, 0, 0, 0.20)'
    },
    primary: {
        50: '{primary.50}',
        100: '{primary.100}',
        200: '{primary.200}',
        300: '{primary.300}',
        400: '{primary.400}',
        500: '{primary.500}',
        600: '{primary.600}',
        700: '{primary.700}',
        800: '{primary.800}',
        900: '{primary.900}',
        950: '{primary.950}'
    },
    formField: {
        fontSize: '0.875rem',     // 14px - consistent base size for all form fields
        paddingX: '0.75rem',
        paddingY: '0.5rem',       // Reduced to better fit 2.5rem height
        sm: {
            fontSize: '0.75rem',   // 12px
            paddingX: '0.625rem',
            paddingY: '0.375rem'
        },
        lg: {
            fontSize: '1rem',      // 16px
            paddingX: '0.875rem',
            paddingY: '0.625rem'
        },
        borderRadius: '{border.radius.md}',
        focusRing: {
            width: '0',
            style: 'none',
            color: 'transparent',
            offset: '0',
            shadow: '0 0 0 0.2rem rgba(239, 70, 0, 0.2)'
        },
        transitionDuration: '{transition.duration}'
    },
    list: {
        padding: '0.375rem',
        gap: '2px',
        header: {
            padding: '0.625rem 0.875rem 0 0.875rem'
        },
        option: {
            padding: '0.625rem 0.875rem',
            borderRadius: '{border.radius.sm}'
        },
        optionGroup: {
            padding: '0.625rem 0.875rem',
            fontWeight: '600'
        }
    },
    content: {
        borderRadius: '{border.radius.md}',
        borderColor: '{surface.border}',
        padding: '1rem'
    },
    mask: {
        transitionDuration: '0.15s'
    },
    navigation: {
        list: {
            padding: '0.375rem',
            gap: '2px'
        },
        item: {
            padding: '0.625rem 0.875rem',
            borderRadius: '{border.radius.sm}',
            gap: '0.5rem'
        },
        submenuLabel: {
            padding: '0.625rem 1rem',
            fontWeight: '600'
        },
        submenuIcon: {
            size: '0.875rem'
        }
    },
    overlay: {
        select: {
            borderRadius: '{border.radius.lg}',
            shadow: '{shadow.md}'
        },
        popover: {
            borderRadius: '{border.radius.lg}',
            padding: '1rem',
            shadow: '{shadow.sm}'
        },
        modal: {
            borderRadius: '{border.radius.xl}',
            padding: '1.5rem',
            shadow: '{shadow.lg}'
        },
        navigation: {
            shadow: '{shadow.md}'
        }
    },
    // Shared dropdown tokens - used by select, menu, tieredmenu, contextmenu
    // Frosted glass panels with generous radius (inspired by YouTube/macOS)
    dropdown: {
        borderRadius: '{border.radius.lg}',
        shadow: '0 4px 16px rgba(0, 0, 0, 0.24)',
        padding: '0.375rem',
        minWidth: '13.75rem',   // ~220px — matches menu min-width
        fontWeight: '400',
        item: {
            padding: '0.625rem 0.875rem',
            borderRadius: '{border.radius.sm}',
            gap: '0.75rem',
            fontSize: '0.875rem'
        },
        separator: {
            margin: '0.375rem 0.5rem'
        }
    },
    colorScheme: {
        light: {
            surface: {
                0: '#FFFFFF',           // White - Main background
                50: '#F7F9FC',          // Very Light Gray/Blue - Cards/Surfaces
                100: '#F7F9FC',         // Same as 50 for consistency
                200: '#E2E8F0',         // Light Gray - Borders
                300: '#E2E8F0',         // Same as 200
                400: '#A0AEC0',         // Medium gray
                500: '#5B6776',         // Slate Gray - Secondary text
                600: '#5B6776',         // Same as 500
                700: '#1A1D21',         // Charcoal - Primary text
                800: '#1A1D21',         // Same as 700
                900: '#1A1D21',         // Same as 700
                950: '#1A1D21',         // Same as 700
                // Custom Branduals surface hierarchy
                ground: '#FFFFFF',      // Alias for main background
                canvas: '#FFFFFF',      // Base layer
                card: '#F7F9FC',        // Content layer
                appChrome: '{surface.50}',   // Frame layer (same as surface-50 in light)
                overlay: '#FFFFFF',     // Floating layer
                border: '#E2E8F0',      // Consistent border color
                hover: 'rgba(0, 0, 0, 0.04)',    // Subtle hover state
                active: 'rgba(0, 0, 0, 0.08)'    // Active state
            },
            primary: {
                color: '#ef4600', // Branduals Orange (same in dark)
                contrastColor: '#ffffff',
                hoverColor: '{primary.600}',
                activeColor: '{primary.700}'
            },
            highlight: {
                background: '{primary.50}',
                focusBackground: '{primary.100}',
                color: '{primary.700}',
                focusColor: '{primary.800}'
            },
            focusRing: {
                shadow: '0 0 0 0.2rem {primary.200}'
            },
            mask: {
                background: 'rgba(0,0,0,0.4)',
                color: '{surface.200}'
            },
            formField: {
                // Transparent fields — hairline-only chrome on both themes (ruled 2026-08-10):
                // the border + orange focus ring carry the editable affordance; disabled keeps
                // its fill so inert fields stay distinguishable.
                background: 'transparent',
                disabledBackground: '{surface.200}',
                filledBackground: '{surface.50}',
                filledHoverBackground: '{surface.50}',
                filledFocusBackground: '{surface.0}',
                borderColor: '{surface.300}',
                hoverBorderColor: '{primary.color}',
                focusBorderColor: '{primary.color}',
                invalidBorderColor: '{red.400}',
                color: '{surface.700}',
                disabledColor: '{surface.500}',
                // Light-theme mirror of the ruled dark placeholder (0.3 white) — at this
                // quiet register the perceptual asymmetry is small, so the alpha mirrors 1:1.
                placeholderColor: 'rgba(0, 0, 0, 0.3)',
                invalidPlaceholderColor: '{red.600}',
                floatLabelColor: '{surface.500}',
                floatLabelFocusColor: '{primary.600}',
                floatLabelActiveColor: '{surface.500}',
                floatLabelInvalidColor: '{form.field.invalid.placeholder.color}',
                iconColor: '{surface.400}',
                shadow: 'none'
            },
            text: {
                color: '#1A1D21',        // Charcoal - Primary text
                hoverColor: '#1A1D21',   // Same for hover
                secondaryColor: '#5B6776',   // Slate Gray - Secondary text
                hoverSecondaryColor: '#5B6776',
                mutedColor: '#A0AEC0',   // Light Gray - Muted text (least important)
                hoverMutedColor: '#A0AEC0'
            },
            content: {
                background: '{surface.0}',
                hoverBackground: '{surface.100}',
                borderColor: '{surface.200}',
                color: '{text.color}',
                hoverColor: '{text.hover.color}'
            },
            overlay: {
                select: {
                    background: 'rgba(255, 255, 255, 0.82)',
                    borderColor: 'rgba(226, 232, 240, 0.6)',
                    color: '{text.color}'
                },
                popover: {
                    background: 'rgba(255, 255, 255, 0.82)',
                    borderColor: 'rgba(226, 232, 240, 0.6)',
                    color: '{text.color}'
                },
                modal: {
                    background: 'rgba(255, 255, 255, 0.88)',
                    borderColor: '{surface.200}',
                    color: '{text.color}'
                }
            },
            list: {
                option: {
                    focusBackground: '{surface.100}',
                    selectedBackground: '{highlight.background}',
                    selectedFocusBackground: '{highlight.focus.background}',
                    color: '{text.color}',
                    focusColor: '{text.hover.color}',
                    selectedColor: '{highlight.color}',
                    selectedFocusColor: '{highlight.focus.color}',
                    icon: {
                        color: '{surface.400}',
                        focusColor: '{surface.500}'
                    }
                },
                optionGroup: {
                    background: 'transparent',
                    color: '{text.color}'
                }
            },
            navigation: {
                item: {
                    focusBackground: '{surface.100}',
                    activeBackground: '{surface.100}',
                    color: '{text.color}',
                    focusColor: '{text.hover.color}',
                    activeColor: '{text.hover.color}',
                    icon: {
                        color: '{surface.400}',
                        focusColor: '{surface.500}',
                        activeColor: '{surface.500}'
                    }
                },
                submenuLabel: {
                    background: 'transparent',
                    color: '{text.color}'
                },
                submenuIcon: {
                    color: '{surface.400}',
                    focusColor: '{surface.500}',
                    activeColor: '{surface.500}'
                }
            },
            // Light theme dropdown colors — frosted glass
            dropdown: {
                background: 'rgba(255, 255, 255, 0.82)',
                borderColor: 'rgba(226, 232, 240, 0.6)',
                color: '{text.color}',
                item: {
                    color: '{text.color}',
                    focusBackground: '{surface.100}',
                    focusColor: '{text.color}',
                    hoverBackground: '{surface.100}',
                    hoverColor: '{text.color}',
                    selectedBackground: '{surface.100}',
                    selectedColor: '{text.color}',
                    selectedFocusBackground: '{surface.200}',
                    selectedFocusColor: '{text.color}',
                    icon: {
                        color: '{text.muted.color}',
                        focusColor: '{text.secondary.color}',
                        hoverColor: '{text.secondary.color}'
                    }
                },
                separator: {
                    borderColor: '{surface.200}'
                },
                submenuIcon: {
                    color: '{text.muted.color}',
                    focusColor: '{text.secondary.color}'
                }
            }
        },
        dark: {
            surface: {
                0: '#1A1D21',           // Darkest - Main background
                50: '#24282F',          // Dark Charcoal - Cards/Surfaces
                100: '#2A2E36',         // Slightly lighter for hover states
                200: '#3A414C',         // Dark Gray - Borders
                300: '#4A515C',         // Medium dark gray
                400: '#5A616C',         // Medium gray
                500: '#6A717C',         // Gray
                600: '#7A818C',         // Light gray
                700: '#8A919C',         // Lighter gray
                800: '#9AA1AC',         // Very light gray
                900: '#AAB1BC',         // Near white
                950: '#BAC1CC',         // Lightest gray
                // Custom Branduals surface hierarchy
                ground: '#1A1D23',      // Main background
                canvas: '#1A1D23',      // Base layer
                card: '#252830',        // Content layer
                appChrome: '{surface.50}',   // Frame layer (uses surface-50 in both light and dark)
                overlay: '#2d313b',     // Floating layer
                border: '#3A414C',      // Consistent border color
                hover: 'rgba(255, 255, 255, 0.05)',    // Subtle hover state
                active: 'rgba(255, 255, 255, 0.1)'     // Active state
            },
            primary: {
                color: '#ef4600',        // Branduals Orange (same in dark)
                contrastColor: '#ffffff',
                hoverColor: '#d73e00',
                activeColor: '#bf3600'
            },
            highlight: {
                background: 'rgba(239, 70, 0, 0.16)',
                focusBackground: 'rgba(239, 70, 0, 0.24)',
                color: 'rgba(255,255,255,.87)',
                focusColor: 'rgba(255,255,255,.87)'
            },
            focusRing: {
                shadow: '0 0 0 0.2rem color-mix(in srgb, {primary.color}, transparent 80%)'
            },
            shadow: {
                xs: '0 1px 2px rgba(0, 0, 0, 0.2)',
                sm: '0 2px 4px rgba(0, 0, 0, 0.3)',
                md: '0 4px 12px rgba(0, 0, 0, 0.4)',
                lg: '0 8px 24px rgba(0, 0, 0, 0.5)',
                xl: '0 12px 48px rgba(0, 0, 0, 0.6)'
            },
            mask: {
                background: 'rgba(0,0,0,0.4)',
                color: '{surface.200}'
            },
            formField: {
                // Transparent fields — hairline-only chrome on both themes (ruled 2026-08-10);
                // see the light colorScheme note.
                background: 'transparent',
                // surface.700 is a LIGHT gray in the dark ramp — disabled fields read inverted/whitish.
                // Dimmed sense = one visible step above the (transparent) field (2026-07-04).
                disabledBackground: '{surface.100}',
                filledBackground: '{surface.800}',
                filledHoverBackground: '{surface.800}',
                filledFocusBackground: '{surface.50}',
                borderColor: '{surface.600}',
                hoverBorderColor: '{primary.color}',
                focusBorderColor: '{primary.color}',
                invalidBorderColor: '{red.300}',
                color: 'rgba(255, 255, 255, 0.87)',
                disabledColor: 'rgba(255, 255, 255, 0.38)',
                placeholderColor: 'rgba(255, 255, 255, 0.3)',
                invalidPlaceholderColor: '{red.400}',
                floatLabelColor: '{surface.400}',
                floatLabelFocusColor: '{primary.color}',
                floatLabelActiveColor: '{surface.400}',
                floatLabelInvalidColor: '{form.field.invalid.placeholder.color}',
                iconColor: '#A0AEC0', // Light gray for better visibility
                shadow: 'none'
            },
            text: {
                color: '#F1F1F1',        // Off-White - Primary text
                hoverColor: '#F1F1F1',   // Same for hover
                secondaryColor: '#A0AEC0',   // Light Gray - Secondary text
                hoverSecondaryColor: '#A0AEC0',
                // #5B6776 measured 2.57:1 on #24282F — WCAG AA failure for the small text this
                // token paints (hints, descriptions, meta). #8B98A9 = 5.05:1 content / 5.77:1
                // page bg; still clearly quieter than secondary (6.6:1) and primary (13:1).
                mutedColor: '#8B98A9',   // Muted text (least important) — AA on dark surfaces (2026-07-04)
                hoverMutedColor: '#8B98A9'
            },
            content: {
                background: '#24282F',    // Dark Charcoal
                hoverBackground: '#2A2E36',
                borderColor: '#3A414C',   // Dark Gray borders
                color: '{text.color}',
                hoverColor: '{text.hover.color}'
            },
            overlay: {
                select: {
                    background: 'rgba(36, 40, 47, 0.78)',
                    borderColor: 'rgba(58, 65, 76, 0.5)',
                    color: '{text.color}'
                },
                popover: {
                    background: 'rgba(36, 40, 47, 0.78)',
                    borderColor: 'rgba(58, 65, 76, 0.5)',
                    color: '{text.color}'
                },
                modal: {
                    background: 'rgba(36, 40, 47, 0.92)',
                    borderColor: '#3A414C',   // Dark Gray
                    color: '{text.color}'
                }
            },
            list: {
                option: {
                    // Aligned with the dark dropdown.item family (2026-07-04) — the legacy
                    // #404040/#094771 values read brown/VS-Code-blue over the charcoal panels.
                    focusBackground: 'rgba(255, 255, 255, 0.08)',
                    selectedBackground: 'rgba(255, 255, 255, 0.12)',
                    selectedFocusBackground: 'rgba(255, 255, 255, 0.16)',
                    color: '{text.color}',
                    focusColor: '{text.hover.color}',
                    selectedColor: '{text.color}',
                    selectedFocusColor: '{text.hover.color}',
                    icon: {
                        color: 'rgba(255, 255, 255, 0.6)',
                        focusColor: 'rgba(255, 255, 255, 0.87)'
                    }
                },
                optionGroup: {
                    background: 'transparent',
                    color: '{text.color}'
                }
            },
            navigation: {
                item: {
                    focusBackground: 'rgba(90, 93, 94, 0.31)',
                    activeBackground: 'rgba(51, 153, 255, 0.15)',
                    color: '{text.color}',
                    focusColor: '{text.hover.color}',
                    activeColor: '{text.hover.color}',
                    icon: {
                        color: 'rgba(255, 255, 255, 0.6)',
                        focusColor: 'rgba(255, 255, 255, 0.87)',
                        activeColor: 'rgba(255, 255, 255, 0.87)'
                    }
                },
                submenuLabel: {
                    background: 'transparent',
                    color: '{text.color}'
                },
                submenuIcon: {
                    color: '{surface.500}',
                    focusColor: '{surface.400}',
                    activeColor: '{surface.400}'
                }
            },
            // Dark theme dropdown colors — frosted glass
            dropdown: {
                background: 'rgba(36, 40, 47, 0.78)',   // Dark charcoal, semi-transparent
                borderColor: 'rgba(58, 65, 76, 0.5)',   // Subtle border, semi-transparent
                color: 'rgba(255, 255, 255, 0.87)',
                item: {
                    color: 'rgba(255, 255, 255, 0.87)',
                    focusBackground: 'rgba(255, 255, 255, 0.08)',
                    focusColor: '#ffffff',
                    hoverBackground: 'rgba(255, 255, 255, 0.08)',
                    hoverColor: '#ffffff',
                    selectedBackground: 'rgba(255, 255, 255, 0.12)',
                    selectedColor: '#ffffff',
                    selectedFocusBackground: 'rgba(255, 255, 255, 0.16)',
                    selectedFocusColor: '#ffffff',
                    icon: {
                        color: 'rgba(255, 255, 255, 0.5)',
                        focusColor: 'rgba(255, 255, 255, 0.87)',
                        hoverColor: 'rgba(255, 255, 255, 0.87)'
                    }
                },
                separator: {
                    borderColor: 'rgba(255, 255, 255, 0.1)'
                },
                submenuIcon: {
                    color: 'rgba(255, 255, 255, 0.5)',
                    focusColor: 'rgba(255, 255, 255, 0.87)'
                }
            }
        }
    }
};

export default {
    primitive,
    semantic
};
